/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum NewsFeedVisibilityType {
    ForPrivateCustomer = 'ForPrivateCustomer',
    ForCompanyCustomer = 'ForCompanyCustomer',
    ForCustomersWithContracts = 'ForCustomersWithContracts',
    ForCustomersWithoutContracts = 'ForCustomersWithoutContracts',
    ForContractDivisionSachversicherung = 'ForContractDivisionSachversicherung',
    ForContractDivisionHaftpflicht = 'ForContractDivisionHaftpflicht',
    ForContractDivisionRechtsschutz = 'ForContractDivisionRechtsschutz',
    ForContractDivisionFinancialLines = 'ForContractDivisionFinancialLines',
    ForContractDivisionTransport = 'ForContractDivisionTransport',
    ForContractDivisionTechnik = 'ForContractDivisionTechnik',
    ForContractDivisionKfz = 'ForContractDivisionKfz',
    ForContractDivisionPerson = 'ForContractDivisionPerson',
    ForContractDivisionSonstige = 'ForContractDivisionSonstige',
    ForTenant = 'ForTenant',
    ForAll = 'ForAll',
    ForGoBeirat = 'ForGoBeirat',
    ForGeschaeftsfuehrer = 'ForGeschaeftsfuehrer',
    ForMakler = 'ForMakler',
    ForBackofficeMitarbeiter = 'ForBackofficeMitarbeiter'
  }

    export const NewsFeedVisibilityTypeTranslocoMap: Record<NewsFeedVisibilityType, string> = {
    [NewsFeedVisibilityType.ForPrivateCustomer]: 'newsFeedVisibilityType.forPrivateCustomer',
    [NewsFeedVisibilityType.ForCompanyCustomer]: 'newsFeedVisibilityType.forCompanyCustomer',
    [NewsFeedVisibilityType.ForCustomersWithContracts]: 'newsFeedVisibilityType.forCustomersWithContracts',
    [NewsFeedVisibilityType.ForCustomersWithoutContracts]: 'newsFeedVisibilityType.forCustomersWithoutContracts',
    [NewsFeedVisibilityType.ForContractDivisionSachversicherung]: 'newsFeedVisibilityType.forContractDivisionSachversicherung',
    [NewsFeedVisibilityType.ForContractDivisionHaftpflicht]: 'newsFeedVisibilityType.forContractDivisionHaftpflicht',
    [NewsFeedVisibilityType.ForContractDivisionRechtsschutz]: 'newsFeedVisibilityType.forContractDivisionRechtsschutz',
    [NewsFeedVisibilityType.ForContractDivisionFinancialLines]: 'newsFeedVisibilityType.forContractDivisionFinancialLines',
    [NewsFeedVisibilityType.ForContractDivisionTransport]: 'newsFeedVisibilityType.forContractDivisionTransport',
    [NewsFeedVisibilityType.ForContractDivisionTechnik]: 'newsFeedVisibilityType.forContractDivisionTechnik',
    [NewsFeedVisibilityType.ForContractDivisionKfz]: 'newsFeedVisibilityType.forContractDivisionKfz',
    [NewsFeedVisibilityType.ForContractDivisionPerson]: 'newsFeedVisibilityType.forContractDivisionPerson',
    [NewsFeedVisibilityType.ForContractDivisionSonstige]: 'newsFeedVisibilityType.forContractDivisionSonstige',
    [NewsFeedVisibilityType.ForTenant]: 'newsFeedVisibilityType.forTenant',
    [NewsFeedVisibilityType.ForAll]: 'newsFeedVisibilityType.forAll',
    [NewsFeedVisibilityType.ForGoBeirat]: 'newsFeedVisibilityType.forGoBeirat',
    [NewsFeedVisibilityType.ForGeschaeftsfuehrer]: 'newsFeedVisibilityType.forGeschaeftsfuehrer',
    [NewsFeedVisibilityType.ForMakler]: 'newsFeedVisibilityType.forMakler',
    [NewsFeedVisibilityType.ForBackofficeMitarbeiter]: 'newsFeedVisibilityType.forBackofficeMitarbeiter',
    };

    export const NewsFeedVisibilityTypeOptions = [
  { value: NewsFeedVisibilityType.ForPrivateCustomer, labelKey: 'newsFeedVisibilityType.forPrivateCustomer' },
  { value: NewsFeedVisibilityType.ForCompanyCustomer, labelKey: 'newsFeedVisibilityType.forCompanyCustomer' },
  { value: NewsFeedVisibilityType.ForCustomersWithContracts, labelKey: 'newsFeedVisibilityType.forCustomersWithContracts' },
  { value: NewsFeedVisibilityType.ForCustomersWithoutContracts, labelKey: 'newsFeedVisibilityType.forCustomersWithoutContracts' },
  { value: NewsFeedVisibilityType.ForContractDivisionSachversicherung, labelKey: 'newsFeedVisibilityType.forContractDivisionSachversicherung' },
  { value: NewsFeedVisibilityType.ForContractDivisionHaftpflicht, labelKey: 'newsFeedVisibilityType.forContractDivisionHaftpflicht' },
  { value: NewsFeedVisibilityType.ForContractDivisionRechtsschutz, labelKey: 'newsFeedVisibilityType.forContractDivisionRechtsschutz' },
  { value: NewsFeedVisibilityType.ForContractDivisionFinancialLines, labelKey: 'newsFeedVisibilityType.forContractDivisionFinancialLines' },
  { value: NewsFeedVisibilityType.ForContractDivisionTransport, labelKey: 'newsFeedVisibilityType.forContractDivisionTransport' },
  { value: NewsFeedVisibilityType.ForContractDivisionTechnik, labelKey: 'newsFeedVisibilityType.forContractDivisionTechnik' },
  { value: NewsFeedVisibilityType.ForContractDivisionKfz, labelKey: 'newsFeedVisibilityType.forContractDivisionKfz' },
  { value: NewsFeedVisibilityType.ForContractDivisionPerson, labelKey: 'newsFeedVisibilityType.forContractDivisionPerson' },
  { value: NewsFeedVisibilityType.ForContractDivisionSonstige, labelKey: 'newsFeedVisibilityType.forContractDivisionSonstige' },
  { value: NewsFeedVisibilityType.ForTenant, labelKey: 'newsFeedVisibilityType.forTenant' },
  { value: NewsFeedVisibilityType.ForAll, labelKey: 'newsFeedVisibilityType.forAll' },
  { value: NewsFeedVisibilityType.ForGoBeirat, labelKey: 'newsFeedVisibilityType.forGoBeirat' },
  { value: NewsFeedVisibilityType.ForGeschaeftsfuehrer, labelKey: 'newsFeedVisibilityType.forGeschaeftsfuehrer' },
  { value: NewsFeedVisibilityType.ForMakler, labelKey: 'newsFeedVisibilityType.forMakler' },
  { value: NewsFeedVisibilityType.ForBackofficeMitarbeiter, labelKey: 'newsFeedVisibilityType.forBackofficeMitarbeiter' },
    ];

